import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from '../locales/en/common.json';
import enAuth from '../locales/en/auth.json';
import enProfile from '../locales/en/profile.json';
import enNav from '../locales/en/nav.json';
import enAdmin from '../locales/en/admin.json';
import enEmployee from '../locales/en/employee.json';
import enPlanning from '../locales/en/planning.json';
import enNotifications from '../locales/en/notifications.json';
import enManager from '../locales/en/manager.json';

import frCommon from '../locales/fr/common.json';
import frAuth from '../locales/fr/auth.json';
import frProfile from '../locales/fr/profile.json';
import frNav from '../locales/fr/nav.json';
import frAdmin from '../locales/fr/admin.json';
import frEmployee from '../locales/fr/employee.json';
import frPlanning from '../locales/fr/planning.json';
import frNotifications from '../locales/fr/notifications.json';
import frManager from '../locales/fr/manager.json';

export const SUPPORTED_LANGUAGES = ['en', 'fr'];
export const DEFAULT_LANGUAGE = 'en';

export function getDateLocale(lang = i18n.language) {
  const code = (lang || DEFAULT_LANGUAGE).split('-')[0];
  return code === 'fr' ? 'fr-FR' : 'en-US';
}

export function normalizeLanguage(lang) {
  if (!lang) return DEFAULT_LANGUAGE;
  const code = String(lang).split('-')[0].toLowerCase();
  return SUPPORTED_LANGUAGES.includes(code) ? code : DEFAULT_LANGUAGE;
}

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    profile: enProfile,
    nav: enNav,
    admin: enAdmin,
    employee: enEmployee,
    planning: enPlanning,
    notifications: enNotifications,
    manager: enManager,
  },
  fr: {
    common: frCommon,
    auth: frAuth,
    profile: frProfile,
    nav: frNav,
    admin: frAdmin,
    employee: frEmployee,
    planning: frPlanning,
    notifications: frNotifications,
    manager: frManager,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: 'common',
    ns: [
      'common',
      'auth',
      'profile',
      'nav',
      'admin',
      'employee',
      'planning',
      'notifications',
      'manager',
    ],
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
    returnEmptyString: false,
    detection: {
      // LanguageContext owns persistence; detector is a browser fallback only
      order: ['navigator'],
      caches: [],
    },
    react: {
      useSuspense: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = normalizeLanguage(lng);
  }
});

if (typeof document !== 'undefined') {
  document.documentElement.lang = normalizeLanguage(i18n.language);
}

export default i18n;
